import TabContent from './TabContent'
import messageResource from '../../../../messageResource'
import {HierarchyLevels} from 'constants'
import {ALL_TABS_EMPTY_KEY} from '../constants'

export default class ManagementAssignmentPanelTabContent extends TabContent {
    tabHeaderTitle() {
        const tab = this.state.openTab

        switch (tab) {
            case HierarchyLevels.TASK:
                return messageResource.getMessage('management_assignment.panel.access_selected_tasks', [], true)
            case HierarchyLevels.PROJECT:
                return messageResource.getMessage('management_assignment.panel.access_selected_projects', [], true)
            case HierarchyLevels.CUSTOMER:
                return messageResource.getMessage('management_assignment.panel.access_selected_customers', [], true)
        }

        return ""
    }

    getRevokeConfirmationText() {
        const tab = this.state.openTab
        const userName = this.state.userFirstName || messageResource.getMessage("common.user")
        let hierarchyLevelName = ""

        switch (tab) {
            case HierarchyLevels.TASK:
                hierarchyLevelName = messageResource.getMessage('common.tasks')
                break
            case HierarchyLevels.PROJECT:
                hierarchyLevelName = messageResource.getMessage('common.projects')
                break
            case HierarchyLevels.CUSTOMER:
                hierarchyLevelName = messageResource.getMessage('common.customers')
                break
        }
        let resultMessage = messageResource.getMessage('management_assignment.panel.revoke_message', [hierarchyLevelName, userName])
        if (this.state.isWASEnabled)
            resultMessage += messageResource.getMessage('management_assignment.panel.revoke_message_note', [hierarchyLevelName])

        return resultMessage
    }

    _setEmptyListTitles() {
        const userName = this.state.userFirstName || messageResource.getMessage("common.user")
        this.emptyList.setState({
            titlesMap: {
                [HierarchyLevels.CUSTOMER]:  messageResource.getMessage("management_assignment.empty_customer_list", [userName]),
                [HierarchyLevels.PROJECT]: messageResource.getMessage("management_assignment.empty_project_list", [userName]),
                [HierarchyLevels.TASK]: messageResource.getMessage("management_assignment.empty_task_list", [userName]),
                [ALL_TABS_EMPTY_KEY]: messageResource.getMessage("management_assignment.empty_list.access_to_scope_not_configured", [userName]),
            },
            noSelectedTitlesMap: {
                [HierarchyLevels.CUSTOMER]:  messageResource.getMessage("management_assignment.empty_customer_list", [userName]),
                [HierarchyLevels.PROJECT]: messageResource.getMessage("management_assignment.no_selected_projects"),
                [HierarchyLevels.TASK]: messageResource.getMessage("management_assignment.no_selected_tasks"),
                [ALL_TABS_EMPTY_KEY]: messageResource.getMessage("management_assignment.no_selected_tasks", [userName]),
            },
            subtitlesAssignItemsMap: {
                [HierarchyLevels.CUSTOMER]: messageResource.getMessage("management_assignment.empty_customer_list.grand_access"),
                [HierarchyLevels.PROJECT]: messageResource.getMessage("management_assignment.empty_project_list.grand_access"),
                [HierarchyLevels.TASK]: messageResource.getMessage("management_assignment.empty_task_list.grand_access"),
                [ALL_TABS_EMPTY_KEY]: messageResource.getMessage("management_assignment.empty_list.grant_access_to_cpt"),

            },
            subtitlesAssignMoreItemsMap: {
                [HierarchyLevels.CUSTOMER]: messageResource.getMessage("management_assignment.empty_customer_list.grand_access_to_more"),
                [HierarchyLevels.PROJECT]: messageResource.getMessage("management_assignment.empty_project_list.grand_access_to_more", [userName]),
                [HierarchyLevels.TASK]: messageResource.getMessage("management_assignment.empty_task_list.grand_access_to_more", [userName]),
                [ALL_TABS_EMPTY_KEY]: messageResource.getMessage("management_assignment.empty_list.grant_access_to_cpt"),
            }
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/hierarchyAssignmentsPanelTab/components/ManagementAssignmentPanelTabContent.js